"use client";

import type { FC } from "react";
import { useMemo } from "react";

import type { HeroV2Props } from "@jti/ui/components/HeroV2";
import { HeroContentAuthoringWrapper } from "@jti/ui/components/HeroV2";

import { ResponsiveBackgroundImage } from "../HeroBannerContainer/ResponsiveBackgroundImage";

import type { heroWithCardsInputs } from "./HeroBannerWithCards.builder";

import heroBannerContainer from "../HeroBannerContainer/HeroBannerContainer.module.scss";

export type HeroBannerProps = BuilderComponentProps<typeof heroWithCardsInputs>;

type BackgroundImageProps = Parameters<NonNullable<ArrayElement<HeroV2Props["data"]>["renderBackgroundImage"]>>[0];

export const HeroBannerWithCards: FC<HeroBannerProps> = ({ data }) => {
  const convertedData = useMemo(() => {
    return {
      ...data,
      renderBackgroundImage: (props: BackgroundImageProps) => <ResponsiveBackgroundImage {...props} index={0} />,
    };
  }, [data]);

  return (
    <div className={heroBannerContainer.fullWidthContainer}>
      <HeroContentAuthoringWrapper data={convertedData} />
    </div>
  );
};

export default HeroBannerWithCards;
